const en = {
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.gui.codeTab": "Code",
    "gui.gui.costumesTab": "Costumes",
    "gui.gui.backdropsTab": "Backdrops",
    "gui.menuBar.wiki": "Download Agent",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.menuBar.turnOffCamera": "Turn Off Camera",
    "gui.connection.scanning.listAll": "Show all available devices",

    // Extension Library Metadata
    "gui.extensionLibrary.comingSoon": "Coming Soon",
    "gui.extensionLibrary.requires": "Requires",
    "gui.extensionLibrary.collaboration": "In collaboration with",
    "gui.extensionLibrary.manufactor": "Manufacturer",
    "gui.extensionLibrary.version": "Version",
    "gui.extensionLibrary.author": "Author",
    "gui.extensionLibrary.programMode": "Program Mode",
    "gui.extensionLibrary.programLanguage": "Program Language",
    "gui.extensionLibrary.deviceLearnMore": "Learn More",
    "gui.extensionLibrary.extensionHelp": "Help",
    "gui.extensionLibrary.Processing": "Processing...",
    "gui.extensionLibrary.loaded": "Loaded",
    "gui.extensionLibrary.notLoaded": "Not Loaded",
    "gui.extensionLibrary.chooseAnExtension": "Choose an Extension",

    // Extension Library Names and Descriptions
    "gui.extension.music.name": "Music",
    "gui.extension.music.description": "Play instruments and drums.",
    "gui.extension.pen.name": "Pen",
    "gui.extension.pen.description": "Draw with your sprites.",
    "gui.extension.videosensing.name": "Video Sensing",
    "gui.extension.videosensing.description": "Sense motion with the camera.",
    "gui.extension.poseface.name": "Face Sensing",
    "gui.extension.poseface.description":
        "Sense face movement with the camera.",
    "gui.extension.posehand.name": "Hand Sensing",
    "gui.extension.posehand.description":
        "Sense hand movement with the camera.",
    "gui.extension.posebody.name": "Body Pose Sensing",
    "gui.extension.posebody.description":
        "Sense body movement with the camera.",
    "gui.extension.teachablemachine.name": "Teachable Machine",
    "gui.extension.teachablemachine.description":
        "Use custom machine learning models with your camera.",
    "gui.extension.text2speech.name": "Text to Speech",
    "gui.extension.text2speech.description": "Make your projects talk.",
    "gui.extension.translate.name": "Translate",
    "gui.extension.translate.description":
        "Translate text into many languages.",
    "gui.extension.makeymakey.name": "Makey Makey",
    "gui.extension.makeymakey.description": "Make anything into a key.",
    "gui.extension.serialprint.name": "Serial Print",
    "gui.extension.serialprint.description": "Print text to serial port.",

    // 'gui.menuBar.community': 'TIFStudio Community',
    "gui.menu-bar.realtimeMode": "Scratch",
    "gui.menu-bar.programMode": "Program",
    "gui.webglModal.description":
        "Unfortunately it looks like your browser or computer {webGlLink}. This technology is needed for TIF Studio to run.",
    "gui.crashMessage.description":
        "We are so sorry, but it looks like TIF Studio has crashed. This bug has been automatically reported to the TIF Studio Team. Please refresh your page to try again.",
    "gui.unsupportedBrowser.notRecommended":
        "We are very sorry, but it looks like you are using a browser version that TIF Studio does not support. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.unsupportedBrowser.description":
        "We are very sorry, but TIF Studio does not support this browser. We recommend updating to the latest version of a supported browser such as Google Chrome, Mozilla Firefox, Microsoft Edge, or Apple Safari.",
    "gui.library.armTag": "Robotic Arm",
    "gui.library.dogTag": "Robotic Dog"
};

export default en;
